import React, { Component } from "react";
import { connect } from "react-redux";
import debounce from "lodash.debounce";
import _ from "i18n";

import {
  setFilterSquads,
  setFilterEntity,
  setClientCRMType,
  setFilterCluster,
  setClientCRMGroup,
  setClientsBudgetState,
  setFilterCollaborators,
  setFilterCollaboratorRole,
  setClientsIsEntityState,
  setClientsStatusBudgetEco,
  setClientsDeletedStatus,
  setClientsBudgetWarningState,
  setClientListPageSize,
  setClientsListFilterTitle
} from "Actions";

import {
  fetchClientsList,
  fetchSquadsSuggestions,
  fetchClusterSuggestions,
  fetchCollaboratorSuggestions
} from "Thunks";

import {
  IS_ENTITY_STATES,
  STATUS_BUDGET_ECO,
  BUDGET_STATUS_FILTER,
  BUDGET_WARNING_FILTER,
  CLIENT_CRM_TYPE_FILTER,
  CLIENT_GROUP_CRM_FILTER,
  DELETED_STATUS
} from "Config";

import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import { NEW_COLLABORATOR_ROLE_FILTER } from "../../config";

class ClientListFilter extends Component {
  constructor(props) {
    super(props);
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 100);
    this.loadCollaboratorSuggestions = debounce(
      this.loadCollaboratorSuggestions,
      1000
    );
    this.loadSquadSuggestions = debounce(this.loadSquadSuggestions, 1000);
    this.loadClusterSuggestions = debounce(this.loadClusterSuggestions, 1000);
  }

  handleSearchInputChange(word) {
    if (word.length > 2) {
      this.props.dispatch(setClientsListFilterTitle(word));
    } else if (word.length === 0) {
      this.props.dispatch(setClientsListFilterTitle(word));
    }
  }

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleListPageSizeChange = selected => {
    this.props.dispatch(setClientListPageSize(selected));
  };
  handleRefreshListClients = () => {
    this.props.dispatch(fetchClientsList());
  };
  handleCollaboratorChange = selected => {
    this.props.dispatch(setFilterCollaborators(selected));
    this.handleRefreshListClients();
  };

  handleCollaboratorRoleChange = selected => {
    this.props.dispatch(setFilterCollaboratorRole(selected));
    this.handleRefreshListClients();
  };

  handleSquadChange = selected => {
    this.props.dispatch(setFilterSquads(selected));
    this.handleRefreshListClients();
  };

  handleClusterChange = selected => {
    this.props.dispatch(setFilterCluster(selected));
    this.handleRefreshListClients();
  };

  handleSetBudgetState = selected => {
    this.props.dispatch(setClientsBudgetState(selected));
  };

  handleSetBudgetWarningFilter = selected => {
    this.props.dispatch(setClientsBudgetWarningState(selected));
  };

  handleSetIsEntityState = isEntity => {
    this.props.dispatch(setClientsIsEntityState(isEntity));
    this.handleRefreshListClients();
  };

  handleSetStatusBudgetEco = statusBudgetEco => {
    this.props.dispatch(setClientsStatusBudgetEco(statusBudgetEco));
    this.handleRefreshListClients();
  };

  handleSetDeletedStatus = selectedStatus => {
    this.props.dispatch(setClientsDeletedStatus(selectedStatus));
    this.handleRefreshListClients();
  };

  handleEntityChange = (selected, isEntity) => {
    selected.length !== 0 ? (isEntity = 0) : (isEntity = "");
    this.props.dispatch(setFilterEntity(selected, isEntity));
    this.handleRefreshListClients();
  };

  handleTypeCRMClientChange = selected => {
    this.props.dispatch(setClientCRMType(selected));
    this.handleRefreshListClients();
  };

  handleGroupCRMClientChange = selected => {
    this.props.dispatch(setClientCRMGroup(selected));
    this.handleRefreshListClients();
  };

  loadSquadSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchSquadsSuggestions(searchWord))
      .then(res => {
        const squads = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(squads);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadClusterSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClusterSuggestions(searchWord))
      .then(res => {
        const clusters = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(clusters);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        const collaborators = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.name,
            color: "#000000"
          };
        });
        callback(collaborators);
      })
      .catch(er => {
        callback([]);
      });
  };

  render() {
    let {
      filter,
      pageSize,
      nbResult,
      fetching,
      customAddOn,
      clientsFilter,
      listFilters,
      getEntity
    } = this.props;
    let filters = [
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: listFilters.squads.selected,
          placeholder: _("squad"),
          handleChange: this.handleSquadChange,
          loadSuggestions: this.loadSquadSuggestions,
          values: listFilters.squads.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: listFilters.cluster.selected,
          placeholder: _("Cluster"),
          handleChange: this.handleClusterChange,
          loadSuggestions: this.loadClusterSuggestions,
          values: listFilters.cluster.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: listFilters.collaborator.selected,
          placeholder: _("collaborator"),
          handleChange: this.handleCollaboratorChange,
          loadSuggestions: this.loadCollaboratorSuggestions,
          values: listFilters.collaborator.selected
        }
      },
      listFilters.collaborator.selected.length > 0 && {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("Dossiers En tant que"),
          options: NEW_COLLABORATOR_ROLE_FILTER,
          values: listFilters.collaborator.role,
          action: this.handleCollaboratorRoleChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("budget warning"),
          options: BUDGET_WARNING_FILTER,
          values: clientsFilter.budgetWarning,
          action: this.handleSetBudgetWarningFilter
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: listFilters.entityClientId.selected,
          placeholder: _("entiteFiltre"),
          handleChange: this.handleEntityChange,
          loadSuggestions: getEntity,
          values: listFilters.entityClientId.selected
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("clientType"),
          options: IS_ENTITY_STATES,
          values: listFilters.entityClientId.isEntity,
          action: this.handleSetIsEntityState
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("StatusBudgHoraire"),
          options: BUDGET_STATUS_FILTER,
          values: clientsFilter.budgetState,
          action: this.handleSetBudgetState
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("StatusBudgEco"),
          options: STATUS_BUDGET_ECO,
          values: listFilters.entityClientId.statusBudgetEco,
          action: this.handleSetStatusBudgetEco
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Type Client (CRM)"),
          options: CLIENT_CRM_TYPE_FILTER,
          values: filter.clientCRMTypes,
          action: this.handleTypeCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Groupe Client (CRM)"),
          options: CLIENT_GROUP_CRM_FILTER,
          values: filter.clientCRMGroup,
          action: this.handleGroupCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("clientState"),
          options: DELETED_STATUS,
          values: listFilters.entityClientId.deletedStatus,
          action: this.handleSetDeletedStatus
        }
      }
    ];
    return (
      <div className="row align-center medium-12">
        <div className="medium-12">
          <TTPFilterHorizontalBar
            button={this.props.button}
            filters={filters}
            pageSize={pageSize}
            customAddOn={customAddOn}
            searchInputValue={clientsFilter.label}
            searchPlaceholder="Search by name or erp id"
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            handleListPageSizeChange={this.handleListPageSizeChange}
            filterFormIsVisible={this.filterFormIsVisible}
            handleResetFilter={this.handleResetFilter}
            cssClass="medium-12"
            nbResult={nbResult}
            label={_("folderNumber")}
            marginLeft={_("10em")}
            fetching={fetching}
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  filter: state.financialSheet.periodTree.filter,
  clientsFilter: state.clients.list.filter,
  listFilters: state.clients.filter,
  lng: state.params.lng
});

export default connect(mapStateToProps)(ClientListFilter);



// WEBPACK FOOTER //
// ./src/components/ClientsList/ClientListFilter.js